
import { React, useState } from "react";
import ReactPaginate from "react-paginate";
import axios from "axios";
import PropTypes from "prop-types";
import { LocationEdit } from "..";
import { Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../styles/Overflow.css";

function LocationTable(props) {
  const { locations, updateTable, setUpdateTable } = props;

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleDelete = (tagId) => {
    const body = new FormData();
    body.append("tagId", tagId);
    axios.post("/faculty/deleteLocation", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setUpdateTable(!updateTable);
      }
      else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const items = locations.map((location, index) => (
    <div key={index}>
      <div className="LocationsRow-container flex rounded-md border-2 border-brand-tertiary drop-shadow-2xl mb-2">
        <div className="LocationsRow-username text-xl flex justify-center font-brand-primary w-1/2 border-r-2 py-2">
          <p className="overFlowBigger">{location.tagName}</p>
        </div>
        <div className="LocationsRow-editDelete text-xl flex justify-center w-1/2 py-2">
          <LocationEdit updateTable={updateTable} setUpdateTable={setUpdateTable} location={location} />
          <button className="flex" onClick={() => handleDelete(location.tagId)}>
            <CloseIcon fontSize="large" className="fill-brand-primary" />
          </button>
        </div>
      </div>
    </div>
  ));

  const itemsPerPage = 5;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  if (locations.length === 0) {
    return <div className="LocationsTable bg-white p-2 rounded-xl w-full">No locations found.</div>;
  } else {
    return (
      <div className="LocationsTable bg-white p-2 rounded-xl w-full">
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={2}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          className="flex w-full justify-between mb-6 mt-4 [&>li>a]:py-4 [&>li>a]:px-6 [&>li>a]:border [&>li>a]:rounded-lg [&>li.selected>a]:border-brand-primary"
        />
        <div className="LocationsRow-container flex rounded-md border-2 border-black drop-shadow-2xl mb-1">
          <div className="LocationsRow-username text-xl flex justify-center font-brand-primary w-1/2 border-black border-r-2 py-2">
            Name
          </div>
          <div className="LocationsRow-editDelete text-xl flex justify-center w-1/2 py-2">
            <div className="flex mr-4">
              Edit
            </div>
            /
            <div className="flex ml-4">
              Delete
            </div>
          </div>
        </div>
        {currentItems}
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

LocationTable.propTypes = {
  locations: PropTypes.arrayOf({
    tagId: PropTypes.number,
    tagName: PropTypes.number,
  }),
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
};

LocationTable.defaultProps = {
  locations: [],
  updateTable: false,
  setUpdateTable: () => { },
};

export default LocationTable;
